export enum ExpandedViewMode {
  DETAILS = 'details',
  PARTS = 'parts',
  QUALITY_CHECK = 'quality_check',
  ATTACHMENTS = 'attachments',
  LINKS = 'links',
}
